import React, { useEffect, useState } from "react";
import api from "../api/api";
import Enable2FA from "../components/Enable2FA";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const ME_ROUTE = import.meta.env.VITE_ME_PATH ?? "/login/me";

    useEffect(() => {
        const load = async () => {
            try {
                const token =
                    localStorage.getItem("authToken") ||
                    localStorage.getItem("token") ||
                    localStorage.getItem("jwt");

                if (!token) {
                    setError("Not authorized.");
                    setLoading(false);
                    return;
                }

                const { data } = await api.get(ME_ROUTE);
                setUser(data);
            } catch (e) {
                setError(
                    e?.response?.data?.message ||
                    e?.message ||
                    "Failed to load profile"
                );
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [ME_ROUTE]);

    if (loading) return <div className="p-6">Loading...</div>;
    if (error) return <div className="p-6 text-red-500">{error}</div>;

    const email = user?.email ?? user?.userName ?? user?.username ?? "";
    const firstName = user?.firstName ?? user?.name ?? "";
    const lastName = user?.lastName ?? user?.surname ?? "";
    const role = user?.role ?? localStorage.getItem("role") ?? "Unknown";

    return (
        <div className="max-w-xl mx-auto mt-8 bg-white p-6 rounded-lg shadow-md">
            <h1 className="text-2xl font-bold mb-4">User Profile</h1>

            <div className="mb-4 space-y-2">
                <div><b>Email:</b> {email}</div>
                <div><b>Name:</b> {firstName} {lastName}</div>
                <div><b>Role:</b> {role}</div>
            </div>

            {/* 🔥 CLIENT PROFILE BUTTON */}
            <button
                className="bg-indigo-600 text-white px-4 py-2 rounded mb-4 w-full"
                onClick={() => navigate("/client")}
            >
                My Client Profile
            </button>

            {/* 🔥 EDIT CLIENT */}
            <button
                className="bg-gray-600 text-white px-4 py-2 rounded mb-4 w-full"
                onClick={() => navigate("/client-form")}
            >
                Edit Client Data
            </button>

            {/* 🔐 2FA */}
            {email && <Enable2FA email={email} />}
        </div>
    );
};

export default ProfilePage;